export default "__VITE_ASSET__1c03b308__"